module.exports = __webpack_public_path__ + "static/img/1.4a9be70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/1.jpg
// module id = yZ2I
// module chunks = 0